import script from "./TwoFactorCodeField.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorCodeField.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorCodeField.vue?vue&type=style&index=0&id=a1f76c9e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1f76c9e"]])

export default __exports__